import { axiosClient } from '@/lib/axios';
import { QueryFunction, useQuery } from '@tanstack/react-query';
import type { Metadata, PaginationParams } from '@/types';
import type { UserData } from '../../types';

type UsersResponseData = {
  data: UserData[];
  metadata: Metadata;
};

type UsersParams = {
  companyID: number;
  queryParams?: {
    sort_by?: keyof UserData;
    sort_dir?: 'asc' | 'desc';
    q?: string;
  } & PaginationParams;
};

export const getUsers = async ({ companyID, queryParams }: UsersParams): Promise<UsersResponseData> => {
  const { data } = await axiosClient.get<UsersResponseData>(`/companies/${companyID}/users`, {
    params: queryParams,
  });
  return data;
};
type QueryFnType = typeof getUsers;

type UseGetUsersOptions = {
  companyID: number;
  queryParams?: UsersParams['queryParams'];
  config?: QueryFunction<QueryFnType>;
};

export const useGetUsers = ({ companyID, queryParams, config }: UseGetUsersOptions) => {
  return useQuery({
    queryKey: ['users', companyID, queryParams],
    queryFn: () => getUsers({ companyID, queryParams }),
    ...config,
  });
};
